import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// components
import Nitrapyrin from 'products/Nitrapyrin';

const baseString = 'vra-manual-fertility-plan-nitrogen-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
let ManualFertilityPlanNitrogenInputs = ({
  disabled,
  isVisible,
  onChangeNitrapyrin,
  plantingPlanParams
}) => {
  return isVisible ? (
    <section className={classString}>
      <section className='vra-planting-plan-form__fieldset'>
        <Nitrapyrin
          disabled={disabled}
          onChange={onChangeNitrapyrin}
          selected={plantingPlanParams.hasNitrapyrin}
        />
      </section>
    </section>
  ) : null;
};
ManualFertilityPlanNitrogenInputs.propTypes = {
  disabled: propTypes.bool,
  isVisible: propTypes.bool.isRequired,
  onChangeNitrapyrin: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired
};
export default ManualFertilityPlanNitrogenInputs;
